import { render, staticRenderFns } from "./MenuGuide.vue?vue&type=template&id=27dcc03f&lang=pug"
import script from "./MenuGuide.vue?vue&type=script&lang=js"
export * from "./MenuGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports